import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { gateway_recommendation_type } from "../../enums";
import {
  useAccountSettings,
  useHookForm,
  useMerchantApiMutation,
} from "../../hooks";
import { IInvoiceSettings } from "../../interfaces-and-types";
import { globalHandlerUtils } from "../../utils";
import { invoiceValidationSchema } from "./validationSchema";

import { View } from "./View";

export const InvoiceTemplate = () => {
  const navigate = useNavigate();

  const {
    // isLoading: isLoadingAccountSettings,
    isSuccess: isSuccessAccountSettings,
    data: accountSettings,
    refreshRemoteData: refreshAccountSettings,
  } = useAccountSettings();

  useEffect(() => {
    accountSettings && reset(accountSettings);
  }, []);

  useEffect(() => {
    if (isSuccessAccountSettings) {
      accountSettings && reset(accountSettings);
    }
  }, [isSuccessAccountSettings]);

  const initialFormValues: IInvoiceSettings = {
    payment_default_memo: null,
    receipt_and_invoice_default_memo: null,
    invoice_days_to_payment_due_default: 30,

    // ...accountSettings,
  };

  const { isSuccess: isSuccessSaveSettings, mutate: saveSettings } =
    useMerchantApiMutation<IInvoiceSettings, IInvoiceSettings>(
      "saveInvoiceSettings"
    ).usePutMutation;

  const handleApiSubmit = (data: IInvoiceSettings) => {
    saveSettings(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, isDirty, errors, register, reset } = useHookForm({
    initialFormValues,
    validationSchema: invoiceValidationSchema,
    onValid: handleApiSubmit,
    onInvalid: handleError,
  });

  useEffect(() => {
    if (isSuccessSaveSettings) {
      refreshAccountSettings();
    }
  }, [isSuccessSaveSettings]);

  const goBack = () => navigate("/settings");

  return (
    <View
      goBack={goBack}
      isDirty={isDirty}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
